// extracted by mini-css-extract-plugin
export default {"wrapper":"spinner_wrapper__wqcap","ldioYc6vm4251k9":"spinner_ldioYc6vm4251k9__6w-jK","loadingioSpinnerSpinner6l6y7wnc6vp":"spinner_loadingioSpinnerSpinner6l6y7wnc6vp__d-zOx"};